<template>
  <div class="layout-header-multi-module-panel" :class="{'is-show-multi-module': showMultiModule}">
    <el-popover
      v-if="showMultiModule || multiVersionName"
      placement="bottom"
      :open-delay="100"
      popper-class="kye-header-multi-popover"
      width="260"
      trigger="hover"
      :disabled="!multiVersionName"
      @show="getMultiModuleInfo()"
      >
      <div>
        <div v-if="multiInfo.frontInfo">【前端环境】：{{ multiInfo.frontInfo }}</div>
        <div v-if="multiInfo.backInfo">【后端环境】：{{ multiInfo.backInfo }}</div>
        <div v-if="multiInfo.description">【说明】：{{ multiInfo.description }}</div>
      </div>
      <div slot="reference" class="multi-title" :class="{'multi-title-inner': showMultiModule}">
        <MultiModuleSelect placement="inner" v-if="showMultiModule" />
        <span class="multi-title-dsc" v-else>{{multiVersionName}}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { ENV } from 'public/config'
import { getShowMultiModule } from '../utils/index.js'
import MultiModuleSelect from './multi-module-select.vue'
export default {
  components: {
    MultiModuleSelect,
  },
  props: {
    multiVersionName: { // 泳道环境-版本名称
      type: String,
      default: '',
    },
    multiInfoId: { // 泳道环境-版本id
      type: String,
      default: '',
    },
  },
  data () {
    return {
      isProd: ENV === 'prd',
      multiInfo: {
        backInfo: '',
        frontInfo: '',
        description: '',
      },
      // 是否显示泳道切换操作
      showMultiModule: false
    }
  },
  mounted() {
    this.getShowMultiModule()
  },
  methods: {
    getShowMultiModule() {
      this.showMultiModule = getShowMultiModule()
    },
    // 获取泳道详细信息
    async getMultiModuleInfo() {
      try {
        if (!this.multiInfoId) return
        const info = await this.$http('fmk.multiVersion.detail', {id: this.multiInfoId}, { appkey: '55111' })
        let backInfo = ''
        let frontInfo = info.erpFront.map(item => item.buildBranch).join('、')
        let description = info.description
        info.backList.length && info.backList.map(item => {
          backInfo += `${item.serviceName}(${item.buildBranch})、 `
        })
        this.multiInfo = {
          ...this.multiInfo,
          backInfo,
          frontInfo,
          description
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.layout-header-multi-module-panel {
  background: var(--g-theme-header-action-bg);
  border-radius: 30px;
  height: 28px;
  margin-right: 12px;
  .multi-title {
    font-size: 12px;
    align-self: end;
    line-height: 20px;
    letter-spacing: 1.2px;
    font-weight: 600;
    &-inner {
      margin-left: 0px;
    }
    &-dsc {
      height: 28px;
      color: var(--g-theme-header-action-color-text);
      display: flex;
      align-items: center;
      font-weight: normal;
      padding: 0 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/multi-module-panel.vue